module.exports = __webpack_public_path__ + "img/founders-divider.015c55a8.png";